'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('benchmark', {
      url: '/benchmark',
      template: '<benchmark></benchmark>'
    });
}
